// removed by extract-text-webpack-plugin
module.exports = {"page":"page__2pY-I","logo":"logo__1dBn2","centerFlex":"centerFlex__2Wp6x","buttonsDiv":"buttonsDiv__24gDj","googleLogin":"googleLogin__36JJP"};


//////////////////
// WEBPACK FOOTER
// ./components/home/home.css
// module id = 9L2j
// module chunks = 0